// extracted by mini-css-extract-plugin
module.exports = {"13F805A":"_620b24c","81E436B":"_de53408"};